import React, { useCallback, useMemo } from 'react';
import { iframeService, isMobile } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import {
  applicationStore,
  freeBetStore,
  userInfoStore,
} from '@pascal/pascal-core/shared/core/store';
import { doBetStore } from '../../store/doBetStore';
import { cardsStore } from '../../store/cardsStore';
import { BetTypesMobileView, BetTypesWebView } from '../../components/betTypesView';
import { winningAmountStore } from '../../store/winningAmountStore';
import { gameStore } from '../../store/gameStore';

export const BetTypesWrapper = observer(() => {
  const { selectedChip, lastBetModel, updateBetsModel, quickBets } = doBetStore;
  const { userId } = userInfoStore;
  const { isDemo } = applicationStore;
  const { isBetsClosed } = gameStore;

  const { playerCards, bankerTotalPoints, playerTotalPoints, bankerCards, selectedCardType } =
    cardsStore;
  const { setLastWin } = winningAmountStore;
  const { activeFreeBet } = freeBetStore;

  const handleDoChip = useCallback(
    (type) => {
      if (
        activeFreeBet.id &&
        lastBetModel.betModel &&
        activeFreeBet.remainingCount - lastBetModel.betModel.length === 0
      ) {
        return;
      }
      if (userId || isDemo) {
        setLastWin(0);
        updateBetsModel({
          type,
          commition: false,
          amount: selectedChip,
        });
      } else {
        iframeService.sendPgLogin();
      }
    },
    [
      activeFreeBet.id,
      activeFreeBet.remainingCount,
      isDemo,
      lastBetModel.betModel,
      selectedChip,
      setLastWin,
      updateBetsModel,
      userId,
    ]
  );

  const chipByTypes = useMemo(() => {
    if (lastBetModel.betModel) {
      return lastBetModel.betModel.reduce((acc, cur) => {
        acc[cur.type] = cur;
        return acc;
      }, {});
    }
    return null;
  }, [lastBetModel]);

  return (
    <div className={`${isMobile() ? 'mob-center-column' : 'bottom-center-column'}`}>
      <div className={`${isMobile() ? 'mob-center-column-inner' : 'bottom-center-column-inner'}`}>
        {isMobile() ? (
          <BetTypesMobileView
            quickBets={quickBets}
            bankerCards={bankerCards}
            chipByTypes={chipByTypes}
            playerCards={playerCards}
            handleDoChip={handleDoChip}
            activeFreeBet={activeFreeBet}
            lastBetModel={lastBetModel}
            bankerTotalPoints={bankerTotalPoints}
            playerTotalPoints={playerTotalPoints}
            selectedCardType={selectedCardType}
          />
        ) : (
          <BetTypesWebView
            quickBets={quickBets}
            bankerCards={bankerCards}
            chipByTypes={chipByTypes}
            playerCards={playerCards}
            handleDoChip={handleDoChip}
            lastBetModel={lastBetModel}
            activeFreeBet={activeFreeBet}
            bankerTotalPoints={bankerTotalPoints}
            playerTotalPoints={playerTotalPoints}
            selectedCardType={selectedCardType}
            isBetsClosed={isBetsClosed}
          />
        )}
      </div>
    </div>
  );
});
